import React, { useEffect } from 'react'
import styled from 'styled-components'
import { images } from '../constants'

const SectionWrapper = styled.section`
  width: 100%;
  height: auto;
  padding: 120px 0 100px;
  @media screen and (max-width: 1023px) {
    padding: 100px 0 80px;
  }
  @media screen and (max-width: 800px) {
    padding: 80px 0 100px;
  }
`
const SectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 86%;
  max-width: var(--max-width);
  margin: 0 auto;
  color: var(--text);
  h2.project-subtitle {
    margin-bottom: 20px;
    color: var(--text);
    font-family: var(--font-condensed);
    font-size: var(--fz-md);
    font-weight: 400;
    text-transform: uppercase;
  }
  h3.project-title {
    margin-bottom: 10px;
    font-family: var(--font-sans);
    font-size: var(--fz-xxl);
    font-weight: 600;
    line-height: 1.5;
    text-transform: uppercase;
  }
  p.project-description {
    padding-right: 60px;
    color: var(--text);
    font-size: var(--fz-lg);
  }
  .button {
    margin: 30px 0 0 0;
  }
  @media screen and (max-width: 800px) {
    flex-direction: column;
    width: calc(100% - 50px);
    margin: 0 25px;
    p.project-description {
      padding-right: 0;
    }
    .button.desc {
      display: none;
    }
  }
`
const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
`
const RightColumn = styled.div`
  width: 100%;
  @media screen and (max-width: 800px) {
    width: calc(100% + 20px);
    margin-top: 70px;
    margin-left: -10px;
  }
  /* SEQUENCE :: START */
  &.sequence.start {
    img.case-page-1 {
      opacity: 1;
      transform: translateY(0px);
      transition: all 500ms 200ms ease;
    }
    img.case-page-2 {
      opacity: 1;
      transform: translateY(25px);
      transition: all 500ms 400ms ease;
    }
  }
`
const StyledWorkImages = styled.div`
  display: flex;
  width: 100%;
  order: 2;
  .images-left,
  .images-right {
    display: flex;
    width: 100%;
    position: relative;
    img.case-page-1 {
      opacity: 0;
      width: 100%;
      height: auto;
      max-width: 260px;
      transform: translateY(100px);
    }
    img.case-page-2 {
      opacity: 0;
      width: 100%;
      height: auto;
      max-width: 260px;
      transform: translateY(125px);
    }
    img.case-bg-1,
    img.case-bg-2 {
      position: absolute;
      width: 100%;
      height: auto;
      max-width: 260px;
    }
    img.case-bg-2 {
      transform: translateY(25px);
    }
  }
  .images-left {
    justify-content: flex-end;
  }
  .images-right {
    justify-content: flex-start;
  }
`
const StyledMobileButton = styled.div`
  display: none;
  @media screen and (max-width: 800px) {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 60px;
  }
`

const HomeProject = () => {
  const handleLinkClick = () => {
    window.dataLayer.push({ event: 'btn_project_binspired' })
  }

  useEffect(() => {
    const items = document.querySelectorAll('.sequence')
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          entry.target.classList.toggle('start', entry.isIntersecting)
          if (entry.isIntersecting) observer.unobserve(entry.target)
        })
      },
      { threshold: 0, rootMargin: '-100px' }
    )
    items.forEach(item => {
      observer.observe(item)
    })

    return () => {
      observer.disconnect()
    }
  }, [])

  return (
    <SectionWrapper>
      <SectionContainer>
        <LeftColumn>
          <h2 className="project-subtitle">Featured Shopify Store</h2>
          <h3 className="project-title">
            <a onClick={handleLinkClick} href="https://www.binspired.com/" target="_blank">
              Binspired
            </a>
          </h3>
          <p className="project-description">I developed a custom Shopify 2.0 theme for Binspired.com with the goal of creating a unique and professional look and feel for the store. The theme was designed to accommodate Binspired's print on demand business model and its Wallart, Living, Tech and Apparel products.</p>
          <a onClick={handleLinkClick} href="https://www.binspired.com" target="_blank" className="button">
            Visit Binspired.com
          </a>
        </LeftColumn>
        <RightColumn className="sequence">
          <StyledWorkImages>
            <div className="images-left">
              <img className="case-bg-1" src={images.project_case_bg} alt="" />
              <img className="case-page-1" src={images.binspired_page_1} alt="Binspired Hompage" />
            </div>
            <div className="images-right">
              <img className="case-bg-2" src={images.project_case_bg} alt="" />
              <img className="case-page-2" src={images.binspired_page_2} alt="Binspired Product Page" />
            </div>
          </StyledWorkImages>
          <StyledMobileButton>
            <a onClick={handleLinkClick} href="https://www.binspired.com" target="_blank" className="button case-page">
              Visit Binspired.com
            </a>
          </StyledMobileButton>
        </RightColumn>
      </SectionContainer>
    </SectionWrapper>
  )
}

export default HomeProject
